/**
 * Production store configuration
 */
import { compose, applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import persistState from 'redux-localstorage';

import myHistory from 'config/history';

import rootReducer from 'modules/index';
import persist from 'config/store/persist.json';
import {myCustomMerge, myCustomSlicer/*, deserializeRedux*/} from 'util/utils';

// Create routing middleware
const reduxRouterMiddleware = routerMiddleware(myHistory);

// Compose the store
// WARNING: if you change structure of this stores, delete localStorage data
const store = compose(
    persistState(persist, {
        slicer: myCustomSlicer,
        merge:  myCustomMerge/*,
        deserialize: deserializeRedux*/
    }),
    applyMiddleware(
        thunkMiddleware,
        reduxRouterMiddleware
    )
)(createStore)(rootReducer);

export default function configureStore() {
    return store;
}



// WEBPACK FOOTER //
// ./src/config/store/configureStore.prod.js